// Client V1 imports
const businessEvents = require('client/lib/business-events')
const globalPageContext = require('client/lib/business-events/page-context')
const { send: ajax } = require('client/lib/request')
const { alert, confirm } = require('client/components/confirm')
// Client V2 imports
const collectionSelectModalActions = require('client-v2/common/containers/collection-select-modal/actions')
const shareModalActions = require('client-v2/common/containers/share-modal/actions')
const extension = require('client-v2/common/utils/extension')

const REPORT_BUTTONS = [
  { label: 'It displays a sensitive image', value: 'image' },
  { label: `It's abusive or harmful`, value: 'nsfl' },
  { label: 'The link is broken', value: 'dead' },
  { label: 'This is my intellectual property', value: 'copyright' },
  { label: 'Cancel', value: '' }
]

function actionsButtons({ article }) {
  const currentPageContext = globalPageContext.getPageContext()
  let lweActions = []
  if (app.store.getState().user.getExperiment('*lightweight_engagement') !== 'disabled') {
    lweActions = [
      { label: `Add this post to your collections`, value: 'add-to-collections' }
    ]
  }
  let shareActions = []
  // The article profile context already has a separate share button
  if (currentPageContext['page_name'] !== 'article.card') {
    shareActions = [
      { label: 'Share this post', value: 'share' }
    ]
  }
  let reportActions = []
  /**
   * Prevent users from reporting their own content
   * @see https://app.asana.com/0/102902769366319/1111869557372309/f
   */
  if (!article.hasMix) {
    reportActions = [
      { label: `I'm not interested in this`, value: 'boring' },
      { label: `This is spam`, value: 'spam' },
      { label: `Stop recommending ${article.hostname}`, value: 'block' },
      { label: 'Additional report options', value: 'report' }
    ]
  }
  return [
    ...lweActions,
    ...shareActions,
    ...reportActions,
    { label: 'Cancel', value: '' }
  ]
}

async function reportArticle({ article, reason, pageContext }) {
  const { 'url_id': urlId } = article
  // WIGGIN ALERT: This depends on the deprecated `wiggin `global object!
  const { id: userId } = window.wiggin.user
  if (reason === 'copyright') {
    if (window.Intercom.trackEvent) {
      // trackEvent may not always be enabled since
      // we don't always capture user data for Intercom
      // see views/partials/scripts/intercom.pug
      window.Intercom.trackEvent('report copyright', {
        'article url': article.url,
        'mix url': window.location.href,
        'url_id': urlId
      })
    }
    window.Intercom('showNewMessage', '')
    return
  }
  await ajax({
    url: '/api/v0.1/reports/url',
    method: 'post',
    data: {
      'url_id': urlId,
      context: reason,
      'page_context': pageContext
    }
  })
  extension.clearUrlCache(urlId)
  await businessEvents.trackSegment('report-url', {
    'url_id': urlId,
    'reporter_id': userId,
    context: reason
  }, {
    pageContext
  })
  alert({
    heading: 'Post Reported',
    subheading: 'Got it - thanks for letting us know!'
  })
  return reason
}

async function blockDomain({ article, pageContext }) {
  const { 'url_id': urlId, hostname } = article
  // WIGGIN ALERT: This depends on the deprecated `wiggin `global object!
  const { id: userId } = window.wiggin.user
  await ajax({
    url: '/api/v0.1/reports/domain',
    method: 'post',
    data: {
      'url_id': urlId,
      'page_context': pageContext
    }
  })
  extension.filterDomain(hostname)
  await businessEvents.trackSegment('report-domain', {
    'url_id': urlId,
    'reporter_id': userId
  }, {
    pageContext
  })
  alert({
    heading: 'Domain Muted',
    subheading: `
      "${hostname}" will no longer be recommended to you,
      but you may still see content from this domain in
      search results and pages curated by users.
    `
  })
  return 'block'
}

async function confirmArticleAction(options) {
  const action = await confirm({
    heading: 'Actions for this Post',
    buttons: actionsButtons(options),
    closeOnBackdropClick: true
  })
  switch (action) {
    case 'boring':
    case 'spam':
      return reportArticle({ ...options, reason: action })
    case 'report':
      return confirmReportReason(options)
    case 'block':
      return blockDomain(options)
    case 'add-to-collections':
      return app.store.dispatch(
        collectionSelectModalActions.show({
          article: options.article,
          anchorId: options.anchorId
        })
      )
    case 'share':
      return app.store.dispatch(
        shareModalActions.show({ model: options.article })
      )
  }
}

async function confirmReportReason(options) {
  const reason = await confirm({
    heading: 'Report Post',
    subheading: 'What is your reason for reporting this post?',
    buttons: REPORT_BUTTONS,
    closeOnBackdropClick: true
  })
  if (reason) {
    return reportArticle({ ...options, reason })
  }
}

module.exports = {
  // Confirm modals
  confirmArticleAction,
  confirmReportReason,
  // Actions
  blockDomain,
  reportArticle
}
